<template>
  <footer class="site-footer" role="contentinfo" aria-label="网站底部信息">
    <div class="wrap">
      <div class="cols">
        <div class="col about" aria-labelledby="about-title">
          <h3 id="about-title">关于 中青网</h3>
          <p>
            中青网为创作者提供专业、授权明确的音乐素材与浏览连载漫画服务，支持商业与非商业项目的创作与传播。
          </p>
          <p class="small">关注我们获取最新素材与活动信息</p>
         
        </div>

        <div class="col links" aria-labelledby="links-title">
          <h4 id="links-title">友情链接</h4>
          <ul>
            <li><a href="https://www.youth.cn" target="_blank" rel="noopener noreferrer">中国青年网</a></li>
            <li><a href="https://www.cycnet.com.cn" target="_blank" rel="noopener noreferrer">中国校园app</a></li>
            <li><a href="http://www.zgzyz.org.cn" target="_blank" rel="noopener noreferrer">中国青年志愿网</a></li>
            <li><a href="https://zhijh.youth.cn/" target="_blank" rel="noopener noreferrer">志愿服务交流会暨中国青年志愿服务项目大赛</a></li>
          </ul>
        </div>

        <div class="col contact" aria-labelledby="contact-title">
          <h4 id="contact-title">联系我们</h4>
          <ul class="contact-list">
            <li>名称：中青网新媒体科技（北京）有限公司</li>
            <!-- <li>地址：北京市朝阳区示例路 100 号</li> -->
            <li>电话：<a href="tel:010-12345678">010-64098960</a></li>
            <li>邮箱：<a href="mailto:biz@zhongqingwang.cn">zqwzbs@126.com</a></li>
            <li>京ICP备13016345号-5</li>
          </ul>
        </div>

        <div class="col newsletter" aria-labelledby="newsletter-title">
          <h4 id="newsletter-title">订阅资讯</h4>
          <p class="small">获取最新素材、活动与优惠（每月一次）</p>
          <form @submit.prevent="subscribe" class="subscribe-form" novalidate>
            <label for="email" class="sr-only">邮箱地址</label>
            <input
              id="email"
              type="email"
              v-model.trim="email"
              placeholder="输入邮箱订阅"
              aria-label="订阅邮箱"
              required
            />
            <button type="submit" :disabled="loading">{{ loading ? '提交中...' : '订阅' }}</button>
          </form>
          <p v-if="message" class="msg" role="status">{{ message }}</p>
        </div>
      </div>

      <div class="bottom">
        <p class="copy">
          © {{ new Date().getFullYear() }} 中青网 &nbsp;|&nbsp; 京ICP备13016345号-5
        </p>
        <p class="policy">
          <router-link to="/PrivacyPolicy" target="_blank">隐私政策</router-link>
          <span>·</span>
          <router-link to="/UserAgreement" target="_blank">用户协议</router-link>
          <span>·</span>
          <router-link to="/minor" target="_blank">未成年人保护指引</router-link>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Nfooter',
  data() {
    return {
      email: '',
      loading: false,
      message: ''
    }
  },
  methods: {
    validateEmail(v) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(v)
    },
    subscribe() {
      this.message = ''
      if (!this.validateEmail(this.email)) {
        this.message = '请输入有效的邮箱地址'
        return
      }
      this.loading = true
      // 这里示例为模拟请求。请替换为真实 API 调用。
      setTimeout(() => {
        this.loading = false
        this.message = '订阅成功，感谢关注！'
        this.email = ''
      }, 900)
    }
  }
}
</script>

<style scoped lang="scss">
.site-footer {
  background: #0f1723;
  color: #e6eef8;
  padding: 40px 16px;
  font-size: 14px;
  .wrap {
    max-width: 1300px;
    margin: 0 auto;
  }

  .cols {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    align-items: start;
    margin-bottom: 24px;
  }

  h3, h4 {
    color: #fff;
    margin-bottom: 8px;
    font-weight: 600;
  }

  p.small {
    color: #b7c7db;
    margin-top: 8px;
  }

  .about p {
    color: #cbdff5;
    line-height: 1.6;
    margin-bottom: 8px;
  }

  .social .icon {
    display: inline-block;
    margin-right: 8px;
    padding: 6px 10px;
    background: rgba(255,255,255,0.04);
    color: #fff;
    border-radius: 4px;
    text-decoration: none;
    font-size: 13px;
  }

  .links ul, .contact-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .contact-list li {
    margin-bottom: 8px;
  }
  .links li {
    margin-bottom: 8px;
  }
  .links a, .contact-list a {
    color: #cbdff5;
    text-decoration: none;
  }
  .links a:hover, .contact-list a:hover {
    color: #7fd1ff;
  }

  .newsletter .subscribe-form {
    display: flex;
    gap: 8px;
    margin-top: 8px;
    input {
      flex: 1;
      padding: 8px 10px;
      border-radius: 4px;
      border: 1px solid rgba(255,255,255,0.08);
      background: rgba(255,255,255,0.03);
      color: #fff;
      outline: none;
    }
    button {
      padding: 8px 12px;
      border-radius: 4px;
      border: none;
      background: #1f9fff;
      color: #fff;
      cursor: pointer;
    }
    button[disabled] {
      opacity: 0.6;
      cursor: default;
    }
  }

  .msg {
    margin-top: 8px;
    color: #9ef0a8;
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid rgba(255,255,255,0.04);
    padding-top: 16px;
    .copy { color: #9fb9d6; }
    .policy a {
      color: #cbdff5;
      text-decoration: none;
      margin-left: 8px;
    }
    .policy span { margin: 0 8px; color: #395a6f; }
  }

  /* 可访问性辅助类 */
  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  /* 响应式 */
  @media (max-width: 980px) {
    .cols {
      grid-template-columns: repeat(2, 1fr);
    }
    .bottom {
      flex-direction: column;
      gap: 8px;
      align-items: flex-start;
    }
  }
  @media (max-width: 560px) {
    .cols {
      grid-template-columns: 1fr;
    }
  }
}
</style>